import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../icon/';

import './style.scss';

const DropdownArrow = ({ ...props }) => {
  return (
    <span className="uni-select__dropdown-arrow" {...props}>
      <Icon type="uiexpandregionvertical" />
    </span>
  );
};

DropdownArrow.propTypes = {
  className: PropTypes.string,
};

export default DropdownArrow;



// WEBPACK FOOTER //
// ./src/selects/__partials/dropdown-arrow/index.jsx